import script from "./LetterPop.vue?vue&type=script&setup=true&lang=js"
export * from "./LetterPop.vue?vue&type=script&setup=true&lang=js"

import "./LetterPop.vue?vue&type=style&index=0&id=478aacfa&scoped=true&lang=css"

import exportComponent from "/Users/muhammadaziziabdulaziz/Documents/VueProject/reeqzan/izznina/clientapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-478aacfa"]])

export default __exports__